import { IBGEEstadoResponse } from "./estadoResponse"
export const IBGE_ESTADOS_GET = 'IBGE_ESTADOS_GET'

export interface IBGEState {
    EstadosBrasil: IBGEEstadoResponse[] | undefined,
}

export interface IBGEEstadosAction {
    type: typeof IBGE_ESTADOS_GET,
    payload: IBGEEstadoResponse[]
}

export type IBGETypes = IBGEEstadosAction